// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeftMenuTemplate {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: row;
}
.LeftMenuTemplate .left-menu {
  overflow-y: auto;
  overflow-x: hidden;
}
.LeftMenuTemplate .left-menu::-webkit-scrollbar {
  width: 6px;
}
.LeftMenuTemplate .left-menu::-webkit-scrollbar-track {
  background: #13323c;
}
.LeftMenuTemplate .left-menu::-webkit-scrollbar-thumb {
  background-color: #275362;
  border-radius: 3px;
}
.LeftMenuTemplate .left-menu::-webkit-scrollbar-thumb:hover {
  background-color: #061216;
}
.LeftMenuTemplate .left-menu {
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #275362 #13323c;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP,
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 {
  background: #275362;
  color: white;
  box-shadow: 0 0 10px #275362;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP {
  position: relative;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP div[role=menu] > div[role=presentation]:not(.sidenav---selected---1EK3y):not(.sidenav---highlighted---oUx9u) {
  background: #275362;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP div[class="sidenav---sidenav-navitem---uwIJ- sidenav---selected---1EK3y sidenav---highlighted---oUx9u"] {
  background: #13323c;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP::-webkit-scrollbar {
  width: 10px;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgb(31, 66, 78);
  background-color: #275362;
  margin-top: 1px;
  margin-bottom: 1px;
}
.LeftMenuTemplate .sidenav---sidenav---_2tBP::-webkit-scrollbar-thumb {
  background-color: #306475;
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgb(69, 93, 101);
  height: 100px;
}
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 .sidenav---navitem---9uL5T:hover {
  background: rgba(0, 0, 0, 0.2) !important;
}
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 .sidenav---navitem---9uL5T {
  padding: 10px;
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
}
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 .sidenav---navitem---9uL5T .sidenav---navicon---3gCRo {
  width: 25px;
  text-align: center;
}
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 .sidenav---navitem---9uL5T .sidenav---navtext---1AE_f {
  padding-left: 45px;
  position: absolute;
  line-height: 4vh;
}
.LeftMenuTemplate .sidenav---sidenav-subnav---1EN61 .sidenav---sidenav-subnavitem---1cD47 > .sidenav---navitem---9uL5T {
  padding: 5px 14px 5px 25px !important;
  color: white;
}
.LeftMenuTemplate .breadcrumbs .disabledBreadcrumb {
  opacity: 1 !important;
}
.LeftMenuTemplate .NavigationContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: hidden;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer {
  display: flex;
  align-items: center;
  padding: 1vw 3vw 0vw 3vw;
  justify-content: space-between;
  margin-bottom: 10px;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .gridOperationDropdown {
  border-radius: 10px;
  box-shadow: 0px 2px 4px 2px lightgrey;
  height: 32px;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .gridOperationDropdown .k-button-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .gridOperationDropdown button {
  background-color: white;
  color: black;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer li span[role=link] {
  text-decoration: none;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb {
  min-width: 0;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-root-link,
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-link {
  display: inline-block;
  color: rgba(0, 0, 0, 0.5450980392);
  overflow: hidden;
  box-shadow: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 193px;
  vertical-align: middle;
  padding-top: 3px;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-root-link:hover,
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-link:hover {
  background-color: lightgray;
  max-width: 1000px;
  text-overflow: hidden;
  outline: none;
  border: 0px solid;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-root-link {
  margin-inline-end: 0;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-last-item .k-breadcrumb-root-link {
  cursor: default;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-last-item .k-breadcrumb-root-link:hover {
  background-color: white;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-link {
  font-weight: 400;
  letter-spacing: 0.8px;
  box-shadow: none;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-item {
  height: 25px;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-item.k-breadcrumb-last-item .k-breadcrumb-link:last-child {
  color: rgb(57, 57, 57);
  font-weight: 600;
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb .k-breadcrumb-item.k-breadcrumb-last-item .k-breadcrumb-link:last-child:hover {
  cursor: default;
  background-color: white;
}
@media screen and (max-width: 430px) {
  .LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .BreadCrumbContainer .k-breadcrumb {
    display: none;
  }
}
.LeftMenuTemplate .NavigationContainer .NavigationHeaderContainer .operationButtons {
  display: flex;
  gap: 8px;
}
.LeftMenuTemplate .NavigationContainer .Navigation .breadcrumbHeader {
  height: 100%;
}

.LeftMenuTemplate.hideMenu nav {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/LeftMenuTemplate.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;AACI;EACE,UAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,yBAAA;EACA,kBAAA;AADN;AAGM;EACE,yBAAA;AADR;AAhBE;EAqBE,YAAA;EACA,qBAAA;EACA,gCAAA;AAFJ;AAKE;;EAEE,mBAAA;EACA,YAAA;EACA,4BAAA;AAHJ;AAKE;EACE,kBAAA;AAHJ;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AASE;EACE,WAAA;AAPJ;AAUE;EACE,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AARJ;AAWE;EACE,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AATJ;AAaI;EACE,yCAAA;AAXN;AAaI;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,2BAAA;AAXN;AAYM;EACE,WAAA;EACA,kBAAA;AAVR;AAYM;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAVR;AAcI;EACE,qCAAA;EACA,YAAA;AAZN;AAiBI;EACE,qBAAA;AAfN;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,kBAAA;AAjBJ;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;AAhBN;AAiBM;EACE,mBAAA;EACA,qCAAA;EACA,YAAA;AAfR;AAgBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAdV;AAgBQ;EACE,uBAAA;EACA,YAAA;AAdV;AAoBU;EACE,qBAAA;AAlBZ;AAqBQ;EACE,YAAA;AAnBV;AAoBU;;EAEE,qBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAlBZ;AAmBY;;EACE,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;AAhBd;AAoBU;EAEE,oBAAA;AAnBZ;AAsBY;EACE,eAAA;AApBd;AAqBc;EACE,uBAAA;AAnBhB;AAwBU;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AAtBZ;AAyBU;EACE,YAAA;EACA,yBAAA,EAAA,WAAA;EACA,qBAAA,EAAA,oBAAA;EACA,iBAAA,EAAA,oBAAA;AAvBZ;AAyBU;EACE,sBAAA;EACA,gBAAA;AAvBZ;AAwBY;EACE,eAAA;EACA,uBAAA;AAtBd;AAyBU;EAvDF;IAwDI,aAAA;EAtBV;AACF;AAyBM;EACE,aAAA;EACA,QAAA;AAvBR;AA4BM;EACE,YAAA;AA1BR;;AAgCE;EACE,aAAA;AA7BJ","sourcesContent":[".LeftMenuTemplate {\n  height: 100%;\n  overflow: auto;\n  display: flex;\n  flex-direction: row;\n\n  .left-menu {\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    &::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #13323c;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #275362;\n      border-radius: 3px;\n\n      &:hover {\n        background-color: #061216;\n      }\n    }\n\n    /* Firefox */\n    scrollbar-width: thin;\n    scrollbar-color: #275362 #13323c;\n  }\n\n  .sidenav---sidenav---_2tBP,\n  .sidenav---sidenav-subnav---1EN61 {\n    background: #275362;\n    color: white;\n    box-shadow: 0 0 10px #275362;\n  }\n  .sidenav---sidenav---_2tBP {\n    position: relative;\n    // overflow-y: auto;\n    // overflow-x: hidden; // added overflow-y : auto [BUG #27964]]\n    div[role=\"menu\"] > div[role=\"presentation\"]:not(.sidenav---selected---1EK3y):not(.sidenav---highlighted---oUx9u) {\n      background: #275362;\n    }\n    div[class=\"sidenav---sidenav-navitem---uwIJ- sidenav---selected---1EK3y sidenav---highlighted---oUx9u\"] {\n      background: #13323c;\n    }\n  }\n\n  // added custom scroll bar for all apps\n  .sidenav---sidenav---_2tBP::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .sidenav---sidenav---_2tBP::-webkit-scrollbar-track {\n    border-radius: 10px;\n    box-shadow: inset 0 0 6px rgb(31, 66, 78);\n    background-color: #275362;\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n\n  .sidenav---sidenav---_2tBP::-webkit-scrollbar-thumb {\n    background-color: #306475;\n    border-radius: 10px;\n    box-shadow: inset 0 0 6px rgb(69, 93, 101);\n    height: 100px;\n  }\n\n  .sidenav---sidenav-subnav---1EN61 {\n    .sidenav---navitem---9uL5T:hover {\n      background: #0003 !important;\n    }\n    .sidenav---navitem---9uL5T {\n      padding: 10px;\n      display: flex !important;\n      align-items: center;\n      justify-content: flex-start;\n      .sidenav---navicon---3gCRo {\n        width: 25px;\n        text-align: center;\n      }\n      .sidenav---navtext---1AE_f {\n        padding-left: 45px;\n        position: absolute;\n        line-height: 4vh;\n      }\n    }\n\n    .sidenav---sidenav-subnavitem---1cD47 > .sidenav---navitem---9uL5T {\n      padding: 5px 14px 5px 25px !important;\n      color: white;\n    }\n  }\n\n  .breadcrumbs {\n    .disabledBreadcrumb {\n      opacity: 1 !important;\n    }\n  }\n  .NavigationContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    // height: 90vh;\n    overflow-y: hidden;\n    .NavigationHeaderContainer {\n      display: flex;\n      align-items: center;\n      padding: 1vw 3vw 0vw 3vw;\n      justify-content: space-between;\n      margin-bottom: 10px;\n      .gridOperationDropdown {\n        border-radius: 10px;\n        box-shadow: 0px 2px 4px 2px lightgrey;\n        height: 32px;\n        .k-button-text {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          font-size: 13px;\n        }\n        button {\n          background-color: white;\n          color: black;\n        }\n      }\n      .BreadCrumbContainer {\n        li {\n          // overiding formio underline style for links\n          span[role=\"link\"] {\n            text-decoration: none;\n          }\n        }\n        .k-breadcrumb {\n          min-width: 0;\n          .k-breadcrumb-root-link,\n          .k-breadcrumb-link {\n            display: inline-block;\n            color: #0000008b;\n            overflow: hidden;\n            box-shadow: none;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            max-width: 193px;\n            vertical-align: middle;\n            padding-top: 3px;\n            &:hover {\n              background-color: lightgray;\n              max-width: 1000px;\n              text-overflow: hidden;\n              outline: none;\n              border: 0px solid;\n            }\n          }\n\n          .k-breadcrumb-root-link {\n            //over riding default kendo styles\n            margin-inline-end: 0;\n          }\n          .k-breadcrumb-last-item {\n            .k-breadcrumb-root-link {\n              cursor: default;\n              &:hover {\n                background-color: white;\n              }\n            }\n          }\n\n          .k-breadcrumb-link {\n            font-weight: 400;\n            letter-spacing: 0.8px;\n            box-shadow: none;\n          }\n\n          .k-breadcrumb-item {\n            height: 25px;\n            -webkit-user-select: none; /* Safari */\n            -ms-user-select: none; /* IE 10 and IE 11 */\n            user-select: none; /* Standard syntax */\n          }\n          .k-breadcrumb-item.k-breadcrumb-last-item .k-breadcrumb-link:last-child {\n            color: rgb(57, 57, 57);\n            font-weight: 600;\n            &:hover {\n              cursor: default;\n              background-color: white;\n            }\n          }\n          @media screen and (max-width: 430px) {\n            display: none;\n          }\n        }\n      }\n      .operationButtons {\n        display: flex;\n        gap: 8px;\n      }\n    }\n\n    .Navigation {\n      .breadcrumbHeader {\n        height: 100%;\n      }\n    }\n  }\n}\n.LeftMenuTemplate.hideMenu {\n  nav {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
